module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div data-region="unit-test-firmware"></div><div data-region="unit-test-functionality"></div><div data-region="unit-test-feedback"></div>';
}
return __p;
};
